module.exports = __webpack_public_path__ + "img/ana-carolina.b9a6f7de.png";